import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';

@Component({
  selector: 'app-pesquisar-listaresultado',
  templateUrl: './pesquisar-listaresultado.component.html',
  styleUrls: ['./pesquisar-listaresultado.component.css']
})
export class PesquisarListaresultadoComponent implements OnInit, OnDestroy {
  hideCL: boolean = false;
  nomeCidade: any = '';
  nomeUF: any = '';
  qBuscado: any = '';
  urlFoto: any = '';
  arrResults: any[] = [];
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    //this.arrResults = [];
    this.hideCL = true;
    this.tmaService.eventoFS(true);
    this.nomeCidade = this.route.snapshot.paramMap.get('cidade');
    this.nomeCidade = this.nomeCidade.replace(new RegExp("\\-", 'g')," ");
    this.nomeUF = this.route.snapshot.paramMap.get('uf');
    this.qBuscado = this.route.snapshot.paramMap.get('tipobuscado');
    console.log(this.modifiers(this.nomeCidade));
    // this.arrResults.push({qq: 1});
    this.obterResultados();
  }
  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
    this.tmaService.gBackBusca = true;
  }

  modifiers(s: any): any{
      var r=s.toLowerCase();
      r = r.replace(new RegExp("\\s", 'g'),"");
      r = r.replace(new RegExp("[àáâãäå]", 'g'),"a");
      r = r.replace(new RegExp("æ", 'g'),"ae");
      r = r.replace(new RegExp("ç", 'g'),"c");
      r = r.replace(new RegExp("[èéêë]", 'g'),"e");
      r = r.replace(new RegExp("[ìíîï]", 'g'),"i");
      r = r.replace(new RegExp("ñ", 'g'),"n");                            
      r = r.replace(new RegExp("[òóôõö]", 'g'),"o");
      r = r.replace(new RegExp("œ", 'g'),"oe");
      r = r.replace(new RegExp("[ùúûü]", 'g'),"u");
      r = r.replace(new RegExp("[ýÿ]", 'g'),"y");
      r = r.replace(new RegExp("\\W", 'g'),"");
      return r;
  };

  obterResultados() :void{
    this.arrResults = [];
    this.hideCL = false;
    var gDados = 'tipopesquisado=' + this.qBuscado + '&uf=' + this.nomeUF + '&cidade=' + this.nomeCidade + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.getLouP(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        this.arrResults = qRes['dadosPesquisa'];
        if(this.qBuscado == 'profissionais'){
          this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
        }
        else{
          this.urlFoto = this.tmaService.urlRepositorioS3 + "/local-logos/";
        }
        
      }
    })
  }


  novaPesquisa() :void{
    localStorage.removeItem("tmsGeoSearch");
    this.router.navigate(['/pesquisando/' +  this.route.snapshot.paramMap.get('tipobuscado')])
  }
  
  goPoL(urlAmigavel: any) :void{
      
      if(this.route.snapshot.paramMap.get('tipobuscado') == 'profissionais'){
        this.tmaService.paginaAnterior = 'lista';
        //this.router.navigate(['/pro/' + urlAmigavel]);
        //anteriormente a ideia era tratar o pro de forma diferente, mas agora vai pra url absoluta (mesma dos usuários comum)
        
        this.router.navigate(['/' + urlAmigavel]);
      }
      else{
        this.tmaService.paginaAnterior = 'lista';
        this.router.navigate(['/local/' + urlAmigavel]);
      }
  }
  trocarCidade() :void{
    localStorage.removeItem("tmsGeoSearch");
    this.router.navigate(['/pesquisando/' +  this.route.snapshot.paramMap.get('tipobuscado')])
  }

  voltar() :void{
    this.router.navigate(['/pesquisar']);
  }
}

